import type { FC } from "react";
import { Button } from "@similarweb/ui-components";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { IDomains } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import { ESelectDomainOptions } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import { translate } from "app/filters/i18nFilter";
import { PlainTooltip } from "@similarweb/ui-components";
import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

const { carbon, blue } = colorsPalettes;

export interface IDomainSelection {
    selectedRows: Array<{ Domain: string; Favicon: string }>;
    clearAllSelectedRows: VoidFunction;
    addDomains: (domains: IDomains) => void;
    isDisabled: boolean;
}

const Container = styled.div<{ isActive: boolean }>`
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    padding: 12px;
    align-items: center;
    background-color: ${({ isActive }) => (isActive ? blue[400] : carbon[50])};
`;

const AddDomainsContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

const Counter = styled.div<{ isActive: boolean }>`
    ${({ isActive }) => setFontVariant("body1", isActive ? carbon[0] : carbon[300])}
`;
export const DomainSelection: FC<IDomainSelection> = (props) => {
    const { clearAllSelectedRows, selectedRows, addDomains, isDisabled = false } = props;
    const { length: selectedRowsAmount } = selectedRows;

    const isActive = selectedRowsAmount > 0;
    const onAdd = () => {
        const selectedDomains: IDomains = selectedRows.map((row) => {
            const { Favicon: favicon, Domain: domain } = row;
            return {
                favicon,
                domain,
                section: ESelectDomainOptions.INDUSTRY,
                type: EAssetType.Website,
                id: domain,
            };
        });
        addDomains(selectedDomains);
        clearAllSelectedRows();
    };
    return (
        <Container isActive={isActive}>
            <AddDomainsContainer>
                <Counter isActive={isActive}>
                    {translate("incomingtraffic.tableselection.selected", {
                        count: selectedRowsAmount,
                    })}
                </Counter>
                <PlainTooltip
                    cssClass="plainTooltip-element"
                    tooltipContent={translate("marketbuilder.import.disable.tooltip")}
                    placement="top"
                    enabled={isDisabled && isActive}
                >
                    <span>
                        <Button
                            onClick={onAdd}
                            type={isActive ? "invertedTransparent" : "flat"}
                            isDisabled={!isActive || isDisabled}
                            dataAutomation="add-domains-button"
                        >
                            {translate("table.selection.add.to.list")}
                        </Button>
                    </span>
                </PlainTooltip>
            </AddDomainsContainer>
            {isActive ? (
                <Button
                    onClick={clearAllSelectedRows}
                    type={"flatNegative"}
                >
                    {translate("table.selection.clear.all")}
                </Button>
            ) : null}
        </Container>
    );
};
